exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "[data-html-img]{max-width:100%;max-height:100%}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./src/playbacks/html_img/public/style.scss
 ** module id = 129
 ** module chunks = 0
 **/